import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_MAINTENANCE_STATUS](state, data) {
    console.log('mutation ', data)
    state.allMaintenanceStatus = data
  },
}
